import { render, staticRenderFns } from "./rider-add.vue?vue&type=template&id=fc1bc166&scoped=true&"
import script from "./rider-add.vue?vue&type=script&lang=js&"
export * from "./rider-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1bc166",
  null
  
)

export default component.exports